import { render, staticRenderFns } from "./M0301ScanRecordIndex.vue?vue&type=template&id=7bd35dd6&scoped=true&"
import script from "./M0301ScanRecordIndex.vue?vue&type=script&lang=js&"
export * from "./M0301ScanRecordIndex.vue?vue&type=script&lang=js&"
import style0 from "./M0301ScanRecordIndex.vue?vue&type=style&index=0&id=7bd35dd6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd35dd6",
  null
  
)

/* custom blocks */
import block0 from "./locales/en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAdmin%2FM0301ScanRecord%2FM0301ScanRecordIndex.vue"
if (typeof block0 === 'function') block0(component)
import block1 from "./locales/zhHant.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvar%2Fwww%2Fhtml%2Facc-web%2Fadmin%2Fsrc%2Fcomponents%2Ffunctions%2FAdmin%2FM0301ScanRecord%2FM0301ScanRecordIndex.vue"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VIcon,VRow})
